import React from 'react';
import type { WizardStepProps } from '../types';
import { FreeTextStep } from './FreeTextStep';

export const StepAbout = (props: WizardStepProps) => <FreeTextStep copyKey="unusual_way_wizard.about" {...props} />;
